import React, { FC } from 'react'

import './Skeleton.scss'

const SkeletonProducts: FC = () => (
  <>
    <div className="pd-skeleton__line pd-skeleton__products-title" />
    <div className="pd-skeleton__products-header">
      <div className="pd-skeleton__products-avatar" />
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '22px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '22px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '22px' }} />
      </div>
    </div>
    <div className="pd-skeleton__products-row">
      <div className="pd-skeleton__products-avatar">
        <div className="pd-skeleton__avatar pd-skeleton__avatar--small" />
      </div>
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '117px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '82px', height: '17px' }} />
      </div>
    </div>
    <div className="pd-skeleton__products-row">
      <div className="pd-skeleton__products-avatar">
        <div className="pd-skeleton__avatar pd-skeleton__avatar--small" />
      </div>
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '117px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '82px', height: '17px' }} />
      </div>
    </div>
    <div className="pd-skeleton__products-row">
      <div className="pd-skeleton__products-avatar">
        <div className="pd-skeleton__avatar pd-skeleton__avatar--small" />
      </div>
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '117px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '82px', height: '17px' }} />
      </div>
    </div>
    <div className="pd-skeleton__products-row">
      <div className="pd-skeleton__products-avatar">
        <div className="pd-skeleton__avatar pd-skeleton__avatar--small" />
      </div>
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '117px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '82px', height: '17px' }} />
      </div>
    </div>
    <div className="pd-skeleton__products-row">
      <div className="pd-skeleton__products-avatar">
        <div className="pd-skeleton__avatar pd-skeleton__avatar--small" />
      </div>
      <div className="pd-skeleton__products-name">
        <div className="pd-skeleton__line" style={{ width: '117px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-type">
        <div className="pd-skeleton__line" style={{ width: '57px', height: '17px' }} />
      </div>
      <div className="pd-skeleton__products-date">
        <div className="pd-skeleton__line" style={{ width: '82px', height: '17px' }} />
      </div>
    </div>
  </>
)

export default SkeletonProducts
